import InstructionsSent from './InstructionsSent';
export default InstructionsSent;
